import { filterNonNull, NString, validateStrEnumValue } from '@mobalytics/shared';
import * as queryString from 'query-string';
import { AppQueryParams, ConnectAccountInfo } from '../types/app.types';
import { SingUpMarketingParams } from '../__generated/accounts/types';
import { Provider } from '../types/provider';
import { Platform } from '../types/platform';
import { DEFAULT_THEME } from '../constants';

export function buildAbsoluteUrl(path: string) {
  return `${window.location.origin}${path}`;
}

export function getEmailsListFromUrl(): string[] | null {
  const queryParams = (queryString.parse(window.location.search) as { email: string[] | string | null | undefined })
    .email;
  if (queryParams) {
    if (typeof queryParams === 'string') {
      return [queryParams];
    }
    if (typeof queryParams === 'object' && queryParams.length) {
      return queryParams;
    }
  }
  return null;
}

function processProviders(providersStr: NString): Provider[] | null {
  if (providersStr) {
    const providers = providersStr.split(',').filter((p) => validateStrEnumValue<Provider>(Provider, p));
    return providers.length ? (providers as Provider[]) : null;
  }
  return null;
}

export function getConnectInfoFromUrl(): ConnectAccountInfo[] | null {
  const infoStr = getEmailsListFromUrl();
  if (infoStr) {
    const result: ConnectAccountInfo[] = infoStr
      .map((str) => {
        const [email, providersStr] = str.split(':');
        const providers = processProviders(providersStr);
        if (email) {
          return { email, providers };
        }
        return null;
      })
      .filter(filterNonNull);
    return result.length ? result : null;
  }
  return null;
}

export function parseAppQueryParams(): AppQueryParams {
  // todo: remove replace when emails templates fixed
  const searchStr = window.location.search.replace(/&amp;/g, '&');
  return queryString.parse(searchStr, { decode: true }) as unknown as AppQueryParams;
}

export function getAppQueryParams(): {
  redirectUri: string | null;
  theme: string;
  marketing: SingUpMarketingParams | null;
  mobaReferrerId: string | null;
} {
  const queryParams = parseAppQueryParams();
  const redirectUri = queryParams.redirect_uri || null;
  const theme = queryParams.theme || DEFAULT_THEME;
  const mobaReferrerId = queryParams.mobaReferrerId || null;

  const marketing: SingUpMarketingParams = {
    platform: queryParams.platform || Platform.WebApp,
    version: queryParams.version,
  };

  return {
    redirectUri,
    theme,
    marketing: Object.keys(marketing).length > 0 ? marketing : null,
    mobaReferrerId,
  };
}
